import script from "./uploadYszg.vue?vue&type=script&setup=true&lang=ts"
export * from "./uploadYszg.vue?vue&type=script&setup=true&lang=ts"

import "./uploadYszg.vue?vue&type=style&index=0&id=780ba9b4&lang=scss"
import "./uploadYszg.vue?vue&type=style&index=1&id=780ba9b4&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-780ba9b4"]])

export default __exports__